export function PlaceholderView({ title, description }: { title: string; description: string }) {
  return (
    <div className="placeholder-view">
      <div className="placeholder-card">
        <strong>{title}</strong>
        <span>{description}</span>
      </div>
    </div>
  );
}
